<ng-template
  #jobDetailModal
  role="dialog"
  tabindex="-1"
  aria-labelledby="modal-label"
  class="modal fade"
>
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title" id="modal-label">Job Log Details</div>
      <button type="button" (click)="close()" class="close" data-dismiss="modal" aria-label="Close" data-testid="job-log-detail-modal-close">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="job-log-info">
        <div class="info-row">
          <div class="label">Timestamp: </div>
          <div class="value">{{getTimestampString(jobLog.timestamp)}}</div>
        </div>

        <div class="info-row">
          <div class="label">Type: </div>
          <div class="value">{{jobLog.logType}}</div>
        </div>

        <div class="info-row">
          <div class="label">User: </div>
          <div class="value">
            <span *ngIf="jobLog.userId">{{jobLog.userName}}</span>
            <span *ngIf="!jobLog.userId">-- System --</span>
          </div>
        </div>

        <div class="info-row">
          <div class="label">Detail: </div>
          <div class="value">{{jobLog.detail}}</div>
        </div>
      </div>

      <table *ngIf="jobLog.details.length > 0" class="mt-3">
        <thead>
          <tr>
            <th>Timestamp</th>
            <th class="text-center">Error</th>
            <th>Detail</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let logDetail of jobLog.details">
            <td>{{getTimestampString(logDetail.timestamp)}}</td>
            <td class="text-center">
              <i *ngIf="logDetail.isError" class="fa fa-xmark text-danger"></i>
            </td>
            <td>{{logDetail.detail}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer d-flex justify-content-end">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="refresh()"
        [disabled]="isRefreshing"
        data-testid="job-log-detail-modal-refresh">
        <i *ngIf="!isRefreshing" class="fa fa-arrows-rotate"></i>
        <i *ngIf="isRefreshing" class="fa fa-spinner fa-spin"></i>
        Refresh
      </button>
      <button
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        class="btn btn-primary"
        (click)="close()"
        data-testid="job-log-detail-modal-footer-close">
        Close
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/developer/logs/job-logs/job-log-detail-modal/job-log-detail-modal.component.html